import React, { useEffect } from 'react';
import styled from 'styled-components';

import { motion } from 'framer-motion';
import ActionBar from './actionBar/ActionBar';
import { CloseSideBtn } from './sideType/DetailStyle';
import Icon from '@components/dataDisplay/Icons/Icon';
import useWindowWidth from '@hooks/useWindowWidth';

const SideWrapper = styled(motion.div)`
  max-width: 380px;
  width: 100%;
  height: 100dvh;
  position: fixed;
  top: 0;
  right: 0;
  background: var(--cardBackgroundColor);
  backdrop-filter: blur(8px);
  z-index: 10;
  border-left: 1px solid var(--lineColor);

  @media (max-width: 480px) {
    max-width: 100%;
    background-color: transparent;
    backdrop-filter: none;
    border-left: 0;
  }
`;

const SideActionBarSec = styled.div`
  padding: 6px 18px;
  @media (max-width: 460px) {
    display: none;
  }
`;
export const sideVariants = {
  initial: {
    x: '10%',
    width: 0,
    opacity: 0,
  },
  in: {
    x: '0',
    height: '100dvh',
    width: 420,
    opacity: 1,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.2,
    },
  },
  out: {
    x: '10%',
    width: 0,
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
};

const mobilesideVariants = {
  initial: {
    x: 0,
    width: '100%',
    opacity: 0,
  },
  in: {
    x: 0,
    height: '100dvh',
    width: '100%',
    opacity: 1,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.2,
    },
  },
  out: {
    x: 0,
    width: '100%',
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
};

interface Props {
  wheelDir?: number;
  setWheelBlock: any;
  SideMap: any;
  closeSide: () => void;
  handleClickActionBarBtn: (actionType: any) => void;
  sideType: string;
  commentCount: number;
  isBookmark: boolean;
  showComment?: boolean;
}

function Sider({
  wheelDir,
  setWheelBlock,
  SideMap,
  closeSide,
  handleClickActionBarBtn,
  sideType,
  commentCount,
  showComment,
  isBookmark,
}: Props) {
  const isMobile = useWindowWidth() < 480;

  useEffect(() => {
    function blockPageScroll(e) {
      e.preventDefault();
    }
    window.addEventListener('scroll', (e) => blockPageScroll);
    return () => window.removeEventListener('scroll', blockPageScroll);
  }, []);

  return (
    <SideWrapper
      initial="initial"
      animate="in"
      exit="out"
      variants={!isMobile ? sideVariants : mobilesideVariants}
      onClick={closeSide}
    >
      <CloseSideBtn onClick={closeSide}>
        <Icon name="X12" />
      </CloseSideBtn>

      <SideActionBarSec onClick={(e) => e.stopPropagation()}>
        <ActionBar
          dir="vertical"
          commentCount={commentCount}
          onClick={handleClickActionBarBtn}
          isBookmark={isBookmark}
          transparent
          tooltipDir="bottom"
          showComment={showComment}
        />
      </SideActionBarSec>

      {SideMap[sideType]}
    </SideWrapper>
  );
}

export default Sider;
